import { render, staticRenderFns } from "./ed-lesson-create-image.vue?vue&type=template&id=4aaee255&scoped=true&"
import script from "./ed-lesson-create-image.ts?vue&type=script&lang=ts&"
export * from "./ed-lesson-create-image.ts?vue&type=script&lang=ts&"
import style0 from "./ed-lesson-create-image.scss?vue&type=style&index=0&id=4aaee255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaee255",
  null
  
)

export default component.exports